// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.paddingFromSelectButtons {
  padding-top: 30px;
}

table {
  color: #ffe8bf;
}

.valueEnaka0 {
  background-color: rgb(26, 95, 173);
}
.valueEnaka100 {
  background-color: yellow;
}
.valueVecKot100 {
  background-color: lightgreen;
}
.valueMed0in100 {
  background-color: lightsalmon;
}
.valueCmpEnak0 {
  background-color: rgb(145, 194, 211);
}
.mat-column-calculate {
  width: 50px !important;
}


#overlay {
  background: #ffffff;
  color: #666666;
  position: fixed;
  height: 100%;
  width: 100%;
  z-index: 5000;
  top: 0;
  left: 0;
  float: left;
  text-align: center;
  padding-top: 25%;
  opacity: .80;
}

.mat-column-title {
  overflow: hidden;
  width:auto;
  word-wrap: break-word;
  padding-right: 10px;
}
.mat-column-saleVal {
  width: 70px !important;
  max-width: 70px !important;
  overflow: hidden;
  padding-right: 5px;
  width:auto;
  white-space: nowrap;
  text-align: right;
}

.mat-column-calculate {
  width: 10% !important;
  overflow: hidden;
  width:auto;
  white-space: nowrap;
}

.mat-row {
  height: auto;
}

.mat-accordion .mat-expansion-panel:last-of-type {
  border-bottom-right-radius: 0px;
  border-bottom-left-radius: 0px;
}

.mat-accordion .mat-expansion-panel:first-of-type {
  border-top-right-radius: 0px;
  border-top-left-radius: 0px;
}
/*.mat-cell {
  padding: 8px 8px 8px 0 !important;
}*/

.mat-expansion-panel-header {
  padding: 0;
  padding-left: 5px;
}

.mat-expansion-indicator {
  display: none;
}

@media(max-width: 900px) {
  .addHeight {
    height: 110px;
  }
}

.mat-expansion-panel-header-description {
  margin: 0;
}

td.mat-cell:last-of-type, td.mat-footer-cell:last-of-type, th.mat-header-cell:last-of-type {
  padding: 0 !important;
}

td.mat-cell:first-of-type, td.mat-footer-cell:first-of-type, th.mat-header-cell:first-of-type {
  padding: 0 !important;
}

.example-spacer {
  flex: 1 0 auto;
}

@media(max-width: 900px){

  .hideIfDesktop {
    display: none;
  }
}
@media(min-width: 900px){

  .hideIfMobile {
    display: none;
  }
}
mat-expansion-panel mat-expansion-panel-header{
    height: auto !important;

}

.bottomRow {
  font-weight: bold;
}

.bottomElementWidth {
  max-width: 35px!important;
  min-width: 35px!important;
  width: 35px!important;
}
`, "",{"version":3,"sources":["webpack://./src/app/sale/sale-skladisce/sale-skladisce.component.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kCAAkC;AACpC;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,oCAAoC;AACtC;AACA;EACE,sBAAsB;AACxB;;;AAGA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,YAAY;EACZ,WAAW;EACX,aAAa;EACb,MAAM;EACN,OAAO;EACP,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,qBAAqB;EACrB,mBAAmB;AACrB;AACA;EACE,sBAAsB;EACtB,0BAA0B;EAC1B,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,+BAA+B;EAC/B,8BAA8B;AAChC;;AAEA;EACE,4BAA4B;EAC5B,2BAA2B;AAC7B;AACA;;EAEE;;AAEF;EACE,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE;IACE,aAAa;EACf;AACF;AACA;;EAEE;IACE,aAAa;EACf;AACF;AACA;IACI,uBAAuB;;AAE3B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,qBAAqB;AACvB","sourcesContent":[".paddingFromSelectButtons {\n  padding-top: 30px;\n}\n\ntable {\n  color: #ffe8bf;\n}\n\n.valueEnaka0 {\n  background-color: rgb(26, 95, 173);\n}\n.valueEnaka100 {\n  background-color: yellow;\n}\n.valueVecKot100 {\n  background-color: lightgreen;\n}\n.valueMed0in100 {\n  background-color: lightsalmon;\n}\n.valueCmpEnak0 {\n  background-color: rgb(145, 194, 211);\n}\n.mat-column-calculate {\n  width: 50px !important;\n}\n\n\n#overlay {\n  background: #ffffff;\n  color: #666666;\n  position: fixed;\n  height: 100%;\n  width: 100%;\n  z-index: 5000;\n  top: 0;\n  left: 0;\n  float: left;\n  text-align: center;\n  padding-top: 25%;\n  opacity: .80;\n}\n\n.mat-column-title {\n  overflow: hidden;\n  width:auto;\n  word-wrap: break-word;\n  padding-right: 10px;\n}\n.mat-column-saleVal {\n  width: 70px !important;\n  max-width: 70px !important;\n  overflow: hidden;\n  padding-right: 5px;\n  width:auto;\n  white-space: nowrap;\n  text-align: right;\n}\n\n.mat-column-calculate {\n  width: 10% !important;\n  overflow: hidden;\n  width:auto;\n  white-space: nowrap;\n}\n\n.mat-row {\n  height: auto;\n}\n\n.mat-accordion .mat-expansion-panel:last-of-type {\n  border-bottom-right-radius: 0px;\n  border-bottom-left-radius: 0px;\n}\n\n.mat-accordion .mat-expansion-panel:first-of-type {\n  border-top-right-radius: 0px;\n  border-top-left-radius: 0px;\n}\n/*.mat-cell {\n  padding: 8px 8px 8px 0 !important;\n}*/\n\n.mat-expansion-panel-header {\n  padding: 0;\n  padding-left: 5px;\n}\n\n.mat-expansion-indicator {\n  display: none;\n}\n\n@media(max-width: 900px) {\n  .addHeight {\n    height: 110px;\n  }\n}\n\n.mat-expansion-panel-header-description {\n  margin: 0;\n}\n\ntd.mat-cell:last-of-type, td.mat-footer-cell:last-of-type, th.mat-header-cell:last-of-type {\n  padding: 0 !important;\n}\n\ntd.mat-cell:first-of-type, td.mat-footer-cell:first-of-type, th.mat-header-cell:first-of-type {\n  padding: 0 !important;\n}\n\n.example-spacer {\n  flex: 1 0 auto;\n}\n\n@media(max-width: 900px){\n\n  .hideIfDesktop {\n    display: none;\n  }\n}\n@media(min-width: 900px){\n\n  .hideIfMobile {\n    display: none;\n  }\n}\nmat-expansion-panel mat-expansion-panel-header{\n    height: auto !important;\n\n}\n\n.bottomRow {\n  font-weight: bold;\n}\n\n.bottomElementWidth {\n  max-width: 35px!important;\n  min-width: 35px!important;\n  width: 35px!important;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
